"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Tooltip = _interopRequireDefault(require("@mui/material/Tooltip"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _styles = require("@mui/styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = (0, _styles.makeStyles)(theme => ({
  text: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    flex: 1
  }
}));
var _default = props => {
  const {
    children,
    innerProps
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip.default, {
    title: children || '',
    enterDelay: 500,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
      className: useStyles().text,
      variant: "subtitle1",
      ...innerProps,
      children: children
    })
  });
};
exports.default = _default;